export function userIsVolunteer(user) {
  return (
    user.userType === 'professional' || user.userType === 'educator'
  );
}

export function userIsStudent(user) {
  return (
    user.userType === 'student'
  );
}

export function userIsAnonymous(user) {
  return (
    user.userType === 'anonymous'
  );
}
